import React from 'react';
import { Box } from '@mui/material';
import StableCKEditor from '../StableCKEditor';
import ClassicEditor from '../../utils/ckeditor';
import { toEditorHtml } from '../../utils/sanitizeHtml';

const DEFAULT_TOOLBAR = [
  'heading', '|', 'bold', 'italic', 'link', '|',
  'bulletedList', 'numberedList', 'blockQuote', '|',
  'undo', 'redo',
];

/**
 * CKEditor mit dem Styling, das MUI-Container brauchen, damit Listen und
 * Blockquotes im Editor so aussehen wie später im Dokument.
 *
 * Bewusst unkontrolliert: CKEditor verwaltet seinen Inhalt selbst, ein
 * `data`-Prop bei jedem Tastendruck neu zu setzen würde den Cursor ans Ende
 * springen lassen. Der Startwert kommt einmal über `initialValue`.
 */
function RichTextField({ initialValue, onChange, onBlur, placeholder, minHeight = 180 }) {
  return (
    <Box
      sx={{
        '& .ck-editor__editable': { minHeight, maxHeight: 520 },
        '& .ck-editor__editable ul, & .ck-editor__editable ol': { paddingLeft: '1.5rem' },
        '& .ck-editor__editable li': { listStyle: 'inherit' },
        '& .ck-editor__editable blockquote': {
          borderLeft: '3px solid #e0e0e0',
          paddingLeft: '12px',
          marginLeft: 0,
          fontStyle: 'italic',
        },
        '& .ck.ck-editor__main>.ck-editor__editable': { borderRadius: '0 0 4px 4px' },
      }}
    >
      <StableCKEditor
        editor={ClassicEditor}
        data={toEditorHtml(initialValue || '')}
        config={{ toolbar: DEFAULT_TOOLBAR, placeholder }}
        onChange={(_event, editor) => onChange && onChange(editor.getData())}
        onBlur={(_event, editor) => onBlur && onBlur(editor.getData())}
      />
    </Box>
  );
}

export default RichTextField;
